// demo中位置对比列表
export const comparisonListData = [
  // {
  //   id: 1,
  //   name: '龙湖杭州滨江天街',
  //   type: 1,
  //   radius: 3,
  //   area: null,
  //   cityName: '杭州',
  //   createTime: '2022-11-02 18:28',
  //   score: 95
  // },
  {
    id: 2,
    name: '宝龙城（杭州滨江店）',
    type: 1,
    radius: 3,
    area: null,
    cityName: '杭州',
    createTime: '2022-11-02 18:38',
    score: 88,
    disabled: false,
  },
  {
    id: 3,
    name: '亲橙里购物中心',
    type: 1,
    radius: 1.5,
    area: null,
    cityName: '杭州',
    createTime: '2022-11-02 18:20',
    score: 87.5,
    disabled: false,
  },
  {
    id: 4,
    name: '西溪银泰城',
    type: 1,
    radius: 1.5,
    area: 1.5,
    cityName: '杭州',
    createTime: '2022-11-02 17:35',
    score: 89.5,
    disabled: false,
  },
  {
    id: 5,
    name: '龙湖虹桥天街购物中心',
    type: 1,
    radius: 3,
    area: null,
    cityName: '上海',
    createTime: '2022-11-02 17:28',
    score: 90.63,
    disabled: false,
  },
];
